import firebase from 'firebase/app';
import 'firebase/auth';

const config = {
	apiKey: 'AIzaSyA0U_0U5oh9hbrKuw96M__0ya4fYea11Kw',
	authDomain: 'printster-9c68d.firebaseapp.com',
	databaseURL: 'https://printster-9c68d.firebaseio.com',
	projectId: 'printster-9c68d',
	storageBucket: 'printster-9c68d.appspot.com',
	messagingSenderId: '458741128863',
	appId: '1:458741128863:web:30dd67b5ad13c644824caa'
};

firebase.initializeApp(config);

export const auth = firebase.auth();

const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });
export const signInWithGoogle = () => auth.signInWithPopup(provider);

export default firebase;
